import API from "./ApiBase.jsx";
//
// export const contactUS = (payload) => {
//     return API.post('/api/v1/PSC /contact', payload);
// };

export const getDataTable = async (url) => {
  return await API.get(url);
};
